import { useDeviceContext } from '@/contexts/DeviceContext';
import { useManifest } from '@/contexts/ManifestContext';
import { useScrollDirection } from '@/hooks/useScrollDirection';
import DesktopHeader from '@/layout/DesktopHeader';
import { useLayout } from '@/layout/LayoutContext';
import { Routes } from '@/routes';
import { cn } from '@/utils/cn';
import React, { ReactNode } from 'react';
import { useLocation } from 'wouter-preact';

interface PageContainerProps {
  className?: string;
  children: ReactNode;
}

const PageContainer: React.FC<PageContainerProps> = ({
  children,
  className = '',
}: PageContainerProps) => {
  const { isTouch } = useDeviceContext();
  const { showHeader } = useLayout();
  const { locale } = useManifest();
  const { direction, scrollY } = useScrollDirection();
  const [location] = useLocation();

  if (!children) return;

  // The home route is "/" or a bare locale prefix like "/en" (see getRouteConfig).
  const isHome =
    location === Routes.Home ||
    locale.supported.some((lang) => location === `/${lang}`);

  // The homepage keeps the header pinned; every other page uses progressive
  // navigation — hide on scroll-down, reveal on scroll-up.
  const headerHidden = !isHome && direction === 'down' && scrollY > 80;

  return (
    <div className={cn(`flex flex-1 flex-col`, className)}>
      {/* The DesktopHeader sits outside <main> so its `sticky` position pins to
          the window (the actual scroll container), not to <main>. */}
      {!isTouch && showHeader && <DesktopHeader hidden={headerHidden} />}
      <main className="flex flex-1 flex-col overflow-x-clip overflow-y-auto">
        {children}
      </main>
    </div>
  );
};

export default PageContainer;
